import { ArrowUp } from "lucide-react";
import { NAV_LINKS, LOGO_SRC, CONTACT_INFO } from "../data/content";

export const Footer = ({ onNavigate }) => (
    <footer data-testid="site-footer" className="relative bg-vec-charcoal text-white border-t border-white/10">
        <div className="vec-container pt-14 sm:pt-16 pb-8">
            <div className="grid grid-cols-12 gap-x-4 gap-y-10 sm:gap-x-8 pb-10 sm:pb-12 border-b border-white/10">
                <div className="col-span-12 lg:col-span-5">
                    <span className="inline-flex bg-white px-4 py-3" data-testid="footer-logo">
                        <img src={LOGO_SRC} alt="VEC — Vijayanand Engineers & Contractors logo" className="h-12 w-auto" loading="lazy" />
                    </span>
                    <p className="mt-6 font-display text-xl sm:text-2xl font-semibold tracking-tight">
                        Vijayanand Engineers &amp; Contractors
                    </p>
                    <p className="mt-2 font-mono-tech text-[11px] uppercase tracking-[0.28em] text-vec-green-bright">
                        Transmitting a Brighter Tomorrow
                    </p>
                    <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/55">
                        Electrical infrastructure and power-sector contracting — transmission,
                        substations, substation O&amp;M and renewable energy works. Established 1997.
                    </p>
                </div>
                <div className="col-span-6 lg:col-span-2">
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.24em] text-white/40">Navigate</p>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.href}>
                                <button
                                    type="button"
                                    data-testid={`footer-${l.testId}`}
                                    onClick={() => onNavigate(l.href)}
                                    className="text-sm text-white/70 hover:text-vec-green-bright transition-colors duration-300"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="col-span-6 lg:col-span-2">
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.24em] text-white/40">Capabilities</p>
                    <ul className="mt-5 space-y-3 text-sm text-white/70">
                        <li>Transmission</li>
                        <li>Substations &amp; O&amp;M</li>
                        <li>Renewable Energy</li>
                        <li>Civil &amp; Infrastructure</li>
                    </ul>
                </div>
                <div className="col-span-12 lg:col-span-3">
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.24em] text-white/40">Contact</p>
                    <ul className="mt-5 space-y-3 text-sm text-white/70">
                        <li>
                            <span className="block font-mono-tech text-[9px] uppercase tracking-[0.2em] text-white/35">Phone</span>
                            {CONTACT_INFO.phone}
                        </li>
                        <li>
                            <span className="block font-mono-tech text-[9px] uppercase tracking-[0.2em] text-white/35">Email</span>
                            {CONTACT_INFO.email}
                        </li>
                        <li>
                            <span className="block font-mono-tech text-[9px] uppercase tracking-[0.2em] text-white/35">Address</span>
                            {CONTACT_INFO.address}
                        </li>
                    </ul>
                </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-7 sm:pt-8">
                <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/40 text-center sm:text-left">
                    © VEC — Vijayanand Engineers &amp; Contractors
                </p>
                <button
                    type="button"
                    data-testid="footer-back-to-top"
                    onClick={() => onNavigate("#top")}
                    className="inline-flex items-center gap-2 border border-white/15 hover:border-vec-green-bright hover:text-vec-green-bright px-4 py-2.5 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/60 transition-colors duration-300"
                    aria-label="Back to top"
                >
                    Back to Top
                    <ArrowUp size={13} aria-hidden="true" />
                </button>
            </div>
        </div>
    </footer>
);
